import { render, staticRenderFns } from "./DoneDeleteButton.vue?vue&type=template&id=4c5c6570"
import script from "./DoneDeleteButton.vue?vue&type=script&lang=js"
export * from "./DoneDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DoneDeleteButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports